export default {
    methods: {
        getFittingStatus(status) {
            switch (status) {
                case 0:
                    return '등록중'
                case 1:
                    return '등록완료'
                case 2:
                    return '삭제'
                case 3:
                    return '등록실패'
                case 4:
                    return '등록대기'
                default:
                    return '-'
            }
        },
    },
}
